import { RouterProvider } from 'react-router';
import { router } from './pages';
import { ThemeProvider } from '@mui/material/styles';
import { aveda } from './themes/aveda';
import CssBaseline from '@mui/material/CssBaseline';
import { NotificationProvider } from './components';

const App = () => {
  return (
    <>
      <ThemeProvider theme={aveda}>
        <CssBaseline />
        <NotificationProvider>
          <RouterProvider router={router} />
        </NotificationProvider>
      </ThemeProvider>
    </>
  );
};

export default App;
